import { NoteKey } from '../hooks';

interface ServiceCardProps {
  title: string;
  description: string;
  details: string;
  icon: string;
  index: number;
  isVisible: boolean;
  onPlayNote: (note: NoteKey) => void;
}

const CARD_NOTES: NoteKey[] = ['C5', 'D5', 'E5', 'G5'];

const ICONS: Record<string, string> = {
  embedded: '⚡',
  hardware: '🔧',
  aiot: '🌐',
  cloud: '☁️',
};

export default function ServiceCard({
  title,
  description,
  details,
  icon,
  index,
  isVisible,
  onPlayNote,
}: ServiceCardProps) {
  return (
    <div
      onMouseEnter={() => onPlayNote(CARD_NOTES[index % CARD_NOTES.length])}
      className="card-3d group relative p-8 rounded-2xl bg-gradient-to-br from-white/5 to-white/[0.02] border border-white/10 hover:border-[var(--cyan-electric)]/50 transition-all duration-500 cursor-pointer"
      style={{
        transitionDelay: `${index * 100}ms`,
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
      }}
    >
      <div className="text-4xl mb-4 transform group-hover:scale-110 transition-transform">
        {ICONS[icon] || icon}
      </div>
      <h3 className="text-2xl font-semibold mb-2">{title}</h3>
      <p className="text-gray-400 mb-2">{description}</p>
      <p className="text-sm text-gray-500 opacity-0 group-hover:opacity-100 transition-opacity">
        {details}
      </p>

      {/* Hover glow effect */}
      <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-[var(--cyan-electric)]/10 to-[var(--amber-warm)]/10 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" />
    </div>
  );
}
